import { Menu } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useSidebar } from '@/components/ui/sidebar'
import { cn } from '@/lib/utils'

interface MobileSidebarMenuButtonProps {
  visible: boolean
  className?: string
}

/** Reveals mobile navigation alongside the app; must render under SidebarProvider. */
export function MobileSidebarMenuButton({ visible, className }: MobileSidebarMenuButtonProps) {
  const { toggleSidebar, openMobile } = useSidebar()

  if (!visible) return null

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn('h-8 w-8 shrink-0', className)}
      onClick={() => toggleSidebar()}
      data-mobile-menu-trigger
      aria-expanded={openMobile}
      aria-label={openMobile ? "Close menu" : "Open menu"}
      title={openMobile ? "Close menu" : "Open menu"}
    >
      <Menu className="h-4 w-4" />
    </Button>
  )
}
